import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Data2Service } from '../../common/data2.service';

@Component({
	selector: 'app-tourism-events-history-drivers',
	templateUrl: './tourism-events-history-drivers.component.html',
	styleUrls: ['./tourism-events-history-drivers.component.css'],
})
export class TourismEventsHistoryDriversComponent implements OnInit {
	private itemsBeforeDataLoad = 0;
	loader = false;
	id: string = null;
	data: Array<any> = [];
	private readonly drivers: Array<any> = [];
	tableRows = [
		{ id: 'updated', name: 'Zaktualizowano' },
		{ id: 'userName', name: 'Użytkownik' },
		{ id: 'type', name: 'Rodzaj kierowcy' },
		{ id: 'driverName', name: 'Kierowca' },
		{ id: 'crew', name: 'Załoga' },
	];

	constructor(
		private readonly api: Data2Service,
		private readonly route: ActivatedRoute,
	) {}

	ngOnInit(): void {
		if (!this.route.snapshot.params['id']) {
			return;
		}
		this.id = this.route.snapshot.params['id'];
		this.loadData();
	}

	private loadData() {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.api.get('/TourismEventsDriversHistory/' + this.id + '/', (result, error) => {
			console.log(result);
			console.log(error);
			this.data = result.data;
			this.loader = false;
		});
	}
}
